module.exports = __webpack_public_path__ + "img/img4.9d162002.jpg";